namespace TR  {

    function Bd4t(funcUtil) {
        let ready = funcUtil.waitForValue(() => {
            //There are unfortunatly two functions called bd4t and need to wait for the second one.
            return window['bd4t'] && window['bd4t'] !== window['firstBd4t'];
        });
        return (...rest) => {
            ready.then(() => {
                try {
                    // Uncomment for testing.
                    // window['bd4tLoggingDate'] = window['bd4tLoggingDate'] || new Date();
                    //
                    // let d:any = new Date();
                    // d = d - window['bd4tLoggingDate'];
                    // d = ('0000' + d);
                    // d.substring(d.length - 5);
                    //
                    // let s = angular.toJson(rest);
                    // s = s.substring(1, s.length-1);
                    // s = `bd4t(${s})`;
                    //
                    // console.log(d, s);

                    window['bd4t'](...rest);
                } catch(er) {}
            });
        };
    }

    angular
        .module('TR')
        .factory('bd4t', Bd4t);
}
